import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventLocationAddChild from "./EventLocationAddChild";

const EventLocationAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventLocationAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventLocationAdd;
